/**
 * This wraps all routes, and is mounted anytime a user is viewing the application.
 * It verifies that a user is authroized to view the application and spawns a token refresh process.
 */

import React from 'react';
import PropTypes from 'prop-types';
import qs from 'qs';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { connect } from 'react-redux';
import { Redirect, Route } from 'react-router-dom';
import PublicShop from 'routes/PublicShop';

import { getDataSelector } from 'redux/selectors';

const AuthorizationHandler = ({ children, history, tokenInfo }) => {
  const { accessToken, user } = tokenInfo.toJS() || {};
  if (!accessToken || !user || !user.id) {
    const { redirect_url: redirectUrl, ...rest } = qs.parse(history.location.search.slice(1));
    const encodedUrl = encodeURIComponent(`${history.location.pathname}?${qs.stringify(rest)}`);
    // if (history.location.pathname === '/order') {
    //   return <Route path="/order" component={PublicShop} />;
    // }
    return <Redirect to={`/?redirect_url=${redirectUrl || encodedUrl}#login`} />;
  }
  return children;
};

AuthorizationHandler.propTypes = {
  children: PropTypes.node.isRequired,
  history: PropTypes.shape({}).isRequired,
  tokenInfo: ImmutablePropTypes.mapContains({
    success: PropTypes.string,
  }).isRequired,
};

/* istanbul ignore next */
const mapStateToProps = state => ({
  tokenInfo: getDataSelector('auth', 'tokenInfo')(state),
});

const wrappedAuthorizationHandler = connect(mapStateToProps)(AuthorizationHandler);
wrappedAuthorizationHandler.displayName = 'AuthorizationHandler';

export default wrappedAuthorizationHandler;
